const paginas = [
  {
    pagina: 1,
    id: 'login',
    nombre: 'LOGIN',
    imagenAyuda: 'imagen',
    pasos: [
      {
        id: 'generics',
        nombre: 'VARIOS',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        elementos: [
          {
            id: 'images_broker',
            tipo: 'imagen',
            descripcion: ''
          },
          {
            id: 'title',
            tipo: 'texto',
            descripcion: ''
          },
          {
            id: 'images_login',
            tipo: 'imagen',
            descripcion: ''
          },
          {
            id: 'images_logout',
            tipo: 'imagen',
            descripcion: ''
          },
          {
            id: 'changeTime',
            tipo: 'texto',
            lista: 'segundos',
            descripcion: ''
          },
        ]
      },
      {
        id: 'backgrounds',
        nombre: 'BACKGROUNDS',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'variable',
        elementos: [
          {
            id: 'agregar',
            tipo: 'addImg',
            descripcion: ''
          },
          {
            id: 'importar',
            tipo: 'impImg',
            descripcion: ''
          },
        ]
      },
      {
        id: 'generics_videoBackground',
        nombre: 'VIDEO',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        advertencia: 'PRIORIDAD.1',
        elementos: [
          {
            id: 'enable',
            tipo: 'check',
            descripcion: '',
            textos: {
              on: 'Si',
              off: 'No'
            }
          },
          {
            id: 'video',
            tipo: 'archivo',
            descripcion: ''
          },
          {
            id: 'loop',
            tipo: 'check',
            descripcion: '',
            textos: {
              on: 'Si',
              off: 'No'
            }
          },
          {
            id: 'mute',
            tipo: 'check',
            descripcion: '',
            textos: {
              on: 'Si',
              off: 'No'
            }
          },
        ]
      },
      {
        id: 'generics_externalContent',
        nombre: 'EXTERNO',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        advertencia: 'PRIORIDAD.2',
        elementos: [
          {
            id: 'enable',
            tipo: 'check',
            descripcion: '',
            textos: {
              on: 'Si',
              off: 'No'
            }
          },
          {
            id: 'url',
            tipo: 'texto',
            advertencia: 'URLEXTERNA',
            descripcion: ''
          },
        ]
      },
    ]
  },
  {
    pagina: 2,
    id: 'home',
    nombre: 'HOME',
    imagenAyuda: 'imagen',
    pasos: [
      {
        id: 'generics_menuBrand',
        nombre: 'BRAND',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        elementos: [
          {
            id: 'logo',
            tipo: 'imagen',
            descripcion: ''
          },
          {
            id: 'name',
            tipo: 'texto',
            descripcion: ''
          },
        ]
      },
      {
        id: 'generics_startingLogo',
        nombre: 'LOGOINICIAL',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        elementos: [
          {
            id: 'show',
            tipo: 'check',
            descripcion: '',
            textos: {
              on: 'Si',
              off: 'No'
            }
          },
          {
            id: 'time',
            tipo: 'texto',
            lista: 'segundos',
            descripcion: ''
          },
          {
            id: 'type',
            tipo: 'texto',
            lista: 'logosIniciales',
            descripcion: ''
          },
        ]
      },
      {
        id: 'generics',
        nombre: 'MOSAICO',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        elementos: [
          {
            id: 'branding_show',
            tipo: 'check',
            descripcion: '',
            textos: {
              on: 'Si',
              off: 'No'
            }
          },
          {
            id: 'branding_image',
            tipo: 'imagen',
            descripcion: ''
          },
          {
            id: 'grayFilter',
            tipo: 'check',
            descripcion: '',
            textos: {
              on: 'Si',
              off: 'No'
            }
          },
          {
            id: 'bgGridColumns',
            tipo: 'texto',
            lista: 'numColumnas',
            descripcion: ''
          },
        ]
      },
      {
        id: 'generics',
        nombre: 'TEMAS',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        elementos: [
          {
            id: 'theme',
            tipo: 'texto',
            lista: 'temas',
            descripcion: ''
          },
        ]
      },
      {
        id: 'backgrounds',
        nombre: 'BACKGROUNDS',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'variable',
        elementos: [
          {
            id: 'agregar',
            tipo: 'addImg',
            descripcion: ''
          },
          {
            id: 'importar',
            tipo: 'impImg',
            descripcion: ''
          },
        ]
      },
      {
        id: 'generics_videoBackground',
        nombre: 'VIDEO',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        advertencia: 'PRIORIDAD.1',
        elementos: [
          {
            id: 'enable',
            tipo: 'check',
            descripcion: '',
            textos: {
              on: 'Si',
              off: 'No'
            }
          },
          {
            id: 'video',
            tipo: 'archivo',
            descripcion: ''
          },
          {
            id: 'loop',
            tipo: 'check',
            descripcion: '',
            textos: {
              on: 'Si',
              off: 'No'
            }
          },
          {
            id: 'mute',
            tipo: 'check',
            descripcion: '',
            textos: {
              on: 'Si',
              off: 'No'
            }
          },
        ]
      },
      {
        id: 'generics_externalContent',
        nombre: 'EXTERNO',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        advertencia: 'PRIORIDAD.2',
        elementos: [
          {
            id: 'enable',
            tipo: 'check',
            descripcion: '',
            textos: {
              on: 'Si',
              off: 'No'
            }
          },
          {
            id: 'url',
            tipo: 'texto',
            advertencia: 'URLEXTERNA',
            descripcion: ''
          },
        ]
      },
      {
        id: 'loaderGif',
        nombre: 'LOADER',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        elementos: [
          {
            id: 'image',
            tipo: 'Gif',
            descripcion: ''
          },
        ]
      },
    ]
  },
  {
    pagina: 3,
    id: 'templates',
    nombre: 'TEMPLATES',
    imagenAyuda: 'imagen',
    pasos: [
      {
        id: '1',
        nombre: 'RT_1',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        elementos: [
          {
            id: 'asunto',
            tipo: 'texto',
            advertencia: 'TEMPLATEFALTANTE',
            descripcion: ''
          },
          {
            id: 'mensaje',
            tipo: 'editorHTML',
            descripcion: ''
          },
          {
            id: 'habilitado',
            tipo: 'activador',
          },
          {
            id: 'idTemplate',
            tipo: 'activador',
          },
        ]
      },
      {
        id: '2',
        nombre: 'RT_2',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        elementos: [
          {
            id: 'asunto',
            tipo: 'texto',
            advertencia: 'TEMPLATEFALTANTE',
            descripcion: ''
          },
          {
            id: 'mensaje',
            tipo: 'editorHTML',
            descripcion: ''
          },
          {
            id: 'habilitado',
            tipo: 'activador',
          },
          {
            id: 'idTemplate',
            tipo: 'activador',
          },
        ]
      },
      {
        id: '3',
        nombre: 'PASS_3',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        elementos: [
          {
            id: 'asunto',
            tipo: 'texto',
            advertencia: 'TEMPLATEFALTANTE',
            descripcion: ''
          },
          {
            id: 'mensaje',
            tipo: 'editorHTML',
            descripcion: ''
          },
          {
            id: 'habilitado',
            tipo: 'activador',
          },
          {
            id: 'idTemplate',
            tipo: 'activador',
          },
        ]
      },
      {
        id: '4',
        nombre: 'PASS_4',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        elementos: [
          {
            id: 'asunto',
            tipo: 'texto',
            advertencia: 'TEMPLATEFALTANTE',
            descripcion: ''
          },
          {
            id: 'mensaje',
            tipo: 'editorHTML',
            descripcion: ''
          },
          {
            id: 'habilitado',
            tipo: 'activador',
          },
          {
            id: 'idTemplate',
            tipo: 'activador',
          },
        ]
      },
      {
        id: '6',
        nombre: 'GETMYCODE_6',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        elementos: [
          {
            id: 'asunto',
            tipo: 'texto',
            advertencia: 'TEMPLATEFALTANTE',
            descripcion: ''
          },
          {
            id: 'mensaje',
            tipo: 'editorHTML',
            descripcion: ''
          },
          {
            id: 'habilitado',
            tipo: 'activador',
          },
          {
            id: 'idTemplate',
            tipo: 'activador',
          },
        ]
      },
      {
        id: '7',
        nombre: 'RT_7',
        imagenAyuda: 'imagen',
        status: 0,
        tipo: 'fijo',
        elementos: [
          {
            id: 'asunto',
            tipo: 'texto',
            advertencia: 'TEMPLATEFALTANTE',
            descripcion: ''
          },
          {
            id: 'mensaje',
            tipo: 'editorHTML',
            descripcion: ''
          },
          {
            id: 'habilitado',
            tipo: 'activador',
          },
          {
            id: 'idTemplate',
            tipo: 'activador',
          },
        ]
      },
    ]
  },
];

export default paginas;
